<div class="nedistribuite-wrap">
    <div class="nedistribuite-header">
        <span class="title">Documente nedistribuite (create, netrimise)</span>
        <span class="badge-total" *ngIf="summary" title="Diferența până la total: documente create dar nerutate">
            {{ summary.total }}
        </span>

        <div class="status-modes">
            <span class="sm-label">Status:</span>
            <button type="button" class="btn btn-sm" [class.btn-primary]="statusMode === 'open'"
                [class.btn-outline-secondary]="statusMode !== 'open'" (click)="setStatusMode('open')"
                title="Doar documentele care nu sunt închise/finalizate">Doar deschise</button>
            <button type="button" class="btn btn-sm" [class.btn-primary]="statusMode === 'closed'"
                [class.btn-outline-secondary]="statusMode !== 'closed'" (click)="setStatusMode('closed')"
                title="Doar închise / finalizate / anulate / arhivate">Închise / finalizate</button>
            <button type="button" class="btn btn-sm" [class.btn-primary]="statusMode === 'all'"
                [class.btn-outline-secondary]="statusMode !== 'all'" (click)="setStatusMode('all')"
                title="Toate documentele nedistribuite">Toate</button>
        </div>
    </div>

    <div class="breakdowns" *ngIf="summary && summary.total > 0">
        <!-- per creator -->
        <div class="bk-col">
            <div class="bk-title">Per utilizator (creator)</div>
            <table class="bk-table">
                <tbody>
                    <tr *ngFor="let u of summary.per_user"
                        [class.selected]="isUserSelected(u)"
                        (click)="onSelectUser(u)"
                        title="Filtrează documentele nedistribuite după acest creator (serviciu)">
                        <td class="bk-name">
                            {{ u.name || ('#' + (u.id_user ?? '—')) }}
                            <div class="bk-sub" *ngIf="u.compartiment_name || u.directie_name">
                                {{ u.compartiment_name || u.directie_name }}
                            </div>
                        </td>
                        <td class="bk-count">{{ u.count }}</td>
                    </tr>
                    <tr *ngIf="summary.per_user.length === 0">
                        <td colspan="2" class="text-muted small">—</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- per tip document -->
        <div class="bk-col">
            <div class="bk-title-row">
                <span class="bk-title">Per tip document</span>
                <button type="button" class="btn btn-sm toggle-btn"
                    [class.btn-info]="tipFilterActive" [class.btn-outline-secondary]="!tipFilterActive"
                    (click)="toggleTipFilter()" title="Activează/dezactivează filtrarea pe tip document">
                    <mat-icon class="align-middle" style="font-size:18px;height:18px;width:18px;">
                        {{ tipFilterActive ? 'toggle_on' : 'toggle_off' }}
                    </mat-icon>
                    Filtrează pe tip
                </button>
            </div>

            <ng-container *ngIf="tipFilterActive">
                <div class="tip-controls">
                    <button type="button" class="btn btn-sm"
                        [class.btn-primary]="selectedTipId === null"
                        [class.btn-outline-secondary]="selectedTipId !== null" (click)="selectAllTipuri()">
                        Toate tipurile
                    </button>
                </div>
                <table class="bk-table">
                    <tbody>
                        <tr *ngFor="let t of summary.per_tip"
                            [class.selected]="selectedTipId === t.id"
                            (click)="onSelectTip(t)"
                            title="Filtrează documentele nedistribuite după acest tip">
                            <td class="bk-name">{{ t.name || ('#' + (t.id ?? '—')) }}</td>
                            <td class="bk-count">{{ t.count }}</td>
                        </tr>
                        <tr *ngIf="summary.per_tip.length === 0">
                            <td colspan="2" class="text-muted small">—</td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
            <div class="bk-hint" *ngIf="!tipFilterActive">
                Activează comutatorul pentru a filtra pe un tip anume.
            </div>
        </div>
    </div>

    <div class="drill-actions" *ngIf="summary && summary.total > 0">
        <button type="button" class="btn btn-sm btn-primary" (click)="afiseazaLista()"
            title="Afișează / reîncarcă lista de documente nedistribuite">
            <mat-icon class="align-middle" style="font-size:16px;height:16px;width:16px;">list_alt</mat-icon>
            Afișează / Încarcă
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary"
            *ngIf="selectedUser !== null || selectedTipId !== null" (click)="clearSubFilters()">
            <mat-icon class="align-middle" style="font-size:16px;height:16px;width:16px;">refresh</mat-icon>
            Resetează filtre
        </button>
        <span class="active-filter" *ngIf="selectedUser !== null">creator selectat</span>
        <span class="active-filter" *ngIf="selectedTipId !== null">tip selectat</span>
    </div>

    <!-- tabelul e MEREU în DOM și vizibil (fix „nu se încarcă"); mesajul propriu acoperă cazul „0" -->
    <div class="drill-down-wrap">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-hover w-100">
            <thead>
                <tr>
                    <th>Serie / Nr. înreg.</th>
                    <th>Data înreg.</th>
                    <th>Creator</th>
                    <th>Categorie</th>
                    <th>Tip document</th>
                    <th>Status</th>
                    <th>Sursă</th>
                    <th>Observații</th>
                    <th class="text-center">Acțiuni</th>
                </tr>
            </thead>
        </table>
        <div class="drill-loader" *ngIf="isLoading">
            <mat-spinner [diameter]="28"></mat-spinner>
        </div>
    </div>
</div>
